export const GIT_REV = "608ce04a";
